// extracted by mini-css-extract-plugin
module.exports = {"form-content":"nTgu5dFu1qpyZUTnfBmnZ","footer-container":"_1YNTzrwmp5qawo8Ar8fxFD","preLoaderShimmer":"_1Bnnim5ScPNh5c3RShyzv5"};